<template>
  <v-flex
    v-if="getSheetDescriptionQuestions.hasOwnProperty('key_needs')"
    id="familyKeyNeeds"
    class="question"
  >
    <h2
      v-if="getSheetDescriptionQuestions.key_needs.hasOwnProperty('label')"
      class="header"
      :class="{ required: getSheetDescriptionQuestions.key_needs.required }"
    >
      {{ getSheetDescriptionQuestions.key_needs.label }}
    </h2>
    <v-layout
      row
      justify-space-between
      wrap
    >
      <v-flex
        xs12
        sm5
      >
        <v-layout
          justify-space-between
          column
        >
          <v-flex xs12>
            <div
              v-if="getSheetDescriptionQuestions.key_needs.hasOwnProperty('text')"
              class="content"
            >
              <p
                v-for="(text, index) in getSheetDescriptionQuestions.key_needs.text"
                :key="index"
              >
                {{ text }}
              </p>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        xs12
        sm6
        :mt-3="xsOnly"
      >
        <div class="input-placeholder pa-3">
          <p class="f-2 fw-600">
            {{ $t('description.family_important_needs.needs') }}
          </p>
          <ul class="ul-decimal">
            <li
              v-for="(item, index) in importantNeeds"
              :key="index"
              class="fw-600"
            >
              <span class="f-1">{{ item.need }}</span>
              <p class="f-1 font-weight-regular formatted-text">
                {{ item.note }}
              </p>
            </li>
          </ul>
        </div>
        <div class="mt-2 ml-1">
          <a
            :disabled="disabledToSheetTwoLink"
            :class="{ disabled: disabledToSheetTwoLink }"
            @click="toSheetTwo"
          >{{ $t('description.family_important_needs.sheet_two') }}</a>
          <div
            v-if="globalFormInvalid"
            class="v-message text-xs-center mt-3 mb-0"
          >
            <div class="v-messages__message">
              {{ $t('errors.form_not_valid') }}
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import statusesId from '@/constants/statusesId';
import endButtonsCondition from '@/mixins/endButtonsCondition';
import { mapGetters } from 'vuex';

export default {
    name: 'FamilyImportantNeeds',
    mixins: [endButtonsCondition],
    inject: ['$validator'],
    props: {
        importantNeeds: {
            default: () => {
                return [];
            }
        },
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            statusesId,
            globalFormInvalid: false
        };
    },
    computed: {
        ...mapGetters('sheet', ['getSheetDescriptionQuestions']),
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        familyId () {
            return this.$route.params.familyId;
        },
        isDraftSaveVisible () {
            return this.$store.getters['sheet/getIsSaveDraftVisible'];
        },
        validProps () {
            return Object.keys(this.fields).map((key) => this.fields[key].valid);
        },
        family () {
            return this.$store.getters['family/getFamily'];
        },
        isFamilyVerified () {
            const _statuses = [
                this.statusesId.FAMILY_VERIFIED_AREA_REACH,
                this.statusesId.FAMILY_VERIFIED_NATIONAL_REACH
            ];
            return _statuses.includes(this.family.status.family_edition_status_id);
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        disabledToSheetTwoLink () {
            return this.readOnly || !this.isCurrentEdition;
        }
    },
    watch: {
        validProps: {
            handler (val) {
                if (!val.includes(false)) {
                    this.globalFormInvalid = false;
                }
            }
        }
    },
    methods: {
        sendSheetCorrections () {
            const _data = {
                familyId: this.familyId,
                sheetType: 'description',
                data: this.$store.getters['description/getDescription']
            };
            return this.$store.dispatch('sheet/sendSheetCorrectionsArea', _data);
        },
        redirectForSheetTwo () {
            this.$router.push({ name: 'sheet-two', params: { id: this.familyId } });
        },
        toSheetTwo () {
            if (this.readOnly === true) {
                return;
            }
            if (this.isDraftSaveVisible !== true && !this.isFamilyVerified && !this.isSheetReturned) {
                this.$validator.validateAll().then((result) => {
                    this.globalFormInvalid = !result;
                    if (result === true) {
                        this.$store
                            .dispatch('sheet/saveSheet', {
                                familyId: this.familyId,
                                sheetType: 'description',
                                data: this.$store.getters['description/getDescription']
                            })
                            .then(() => {
                                this.clearValidatorFlag();
                                this.redirectForSheetTwo();
                            });
                    }
                });
            } else if (!this.isFamilyVerified && !this.isSheetReturned) {
                this.$store
                    .dispatch('sheet/saveDraftSheet', {
                        familyId: this.familyId,
                        sheetType: 'description',
                        data: this.$store.getters['description/getDescription']
                    })
                    .then(() => {
                        this.clearValidatorFlag();
                        this.redirectForSheetTwo();
                    });
            } else if (this.isSheetReturned) {
                this.sendSheetCorrections().then(() => {
                    this.clearValidatorFlag();
                    this.redirectForSheetTwo();
                });
            } else {
                this.redirectForSheetTwo();
            }
        },
        clearValidatorFlag () {
            Object.keys(this.$validator.flags).forEach((x) => {
                this.$validator.flags[x].changed = false;
            });
        }
    }
};
</script>

<style scoped></style>
